export default {

  required: {
    message : "Age in not set",
    fn      : (input)=>  Boolean(input)
  },

  min: {
    message : "Age must be greater than 0.",
    fn      : (input)=>  Number(input) > 0
  }
}
